module.exports = __webpack_public_path__ + "img/unicorn.a2fe2714.gif";